import { Colors } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

export default class MyAccountInfo extends lng.Component {
  static _template() {
    return {
      MyEmailAdress: {
        y: 197,
        x: 1050,
        text: {
          text: 'My Email Address',
          fontSize: 36,
          fontFace: 'OpenSans-SemiBold',
          textColor: Colors('#fafafa').get(),
        },
        Email: {
          y: 80,
          x: 27,
          text: {
            textColor: Colors('#d6d6d6').get(),
            fontFace: 'OpenSans-Regular',
            text: '',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            fontSize: 35,
            wordWrapWidth: 800,
            maxLines: 2,
            wordWrap: false,
          },
        },
      },
      MyPlan: {
        y: 395,
        x: 1050,
        text: {
          text: 'My Plan',
          fontSize: 36,
          textColor: Colors('#fafafa').get(),
          fontFace: 'OpenSans-SemiBold',
        },
        MonthlyStreaming: {
          x: 30,
          y: 85,
          text: {
            text: 'Monthly Streaming',
            fontSize: 36,
            textColor: Colors('#d6d6d6').get(),
            fontFace: 'OpenSans-SemiBold',
          },
          ConcurrentStreams: {
            y: 65,
            text: {
              text: `Concurrent Streams:`,
              fontFace: 'OpenSans-Regular',
              fontSize: 36,
              textColor: Colors('#d6d6d6').get(),
            },
          },
          ActiveStreams: {
            y: 130,
            text: {
              text: `Active Streams:`,
              fontFace: 'OpenSans-Regular',
              fontSize: 36,
              textColor: Colors('#d6d6d6').get(),
            },
          },
        },
      },
      ContactInfo: {
        y: 690,
        x: 1055,
        text: {
          text: 'To change your plan, call 800-548-4647',
          fontFace: 'OpenSans-Regular',
          fontSize: 36,
          textColor: Colors('#fafafa').get(),
        },
      },
    };
  }

  set active_streams(val) {
    this._active_streams = val;
  }

  set max_concurrent_streams(val) {
    this._max_concurrent_streams = val;
  }

  set email(val) {
    return (this._email = val);
  }

  get _ActiveStreams() {
    return this.tag('ActiveStreams');
  }

  get _ConcurrentStreams() {
    return this.tag('ConcurrentStreams');
  }
  get _Email() {
    return this.tag('Email');
  }

  _firstEnable() {
    this._ActiveStreams.patch({
      text: {
        text: `Active Streams: ${this._active_streams}`,
      },
    });
    this._ConcurrentStreams.patch({
      text: {
        text: `Concurrent Streams: ${this._max_concurrent_streams}`,
      },
    });

    this._Email.patch({
      text: {
        text: this._email,
      },
    });
  }

  _construct() {
    super._construct();
    this.spacing = 0;
  }
}
